(ns com.theplantscape.plant-web.draw.api
  (:require [ajax.core
             :refer
             [ajax-request
              json-request-format
              json-response-format
              transit-request-format
              transit-response-format]]
            [clojure.core.async :refer [put! <! >! chan go]]
            [malli.core :as m]
            [malli.error :as me]
            [com.theplantscape.plant-web.draw.state :refer [site-state]]
            [com.theplantscape.plant-web.draw.constants :refer [api-url-build]]))

(defonce get-transit-defaults
  {:method :get
   :format (transit-request-format)
   :response-format (transit-response-format {:keywords? true})
   :keywords? true})

(defonce get-json-defaults
  {:method :get
   :format (json-request-format)
   :response-format (json-response-format {:keywords? true})
   :keywords? true})

(defn handle-failure [{:keys [status status-text response] :as res}]
  (prn (-> response :humanized ))
  (prn (-> response :schema :humanized))
  (when (= 400 status)
    (swap! site-state
           assoc :notifications
           [{:msg (str (-> response :humanized ))}]))
  (prn (me/humanize (:schema response)))
  (prn "api request failed"))

(defn wrap-response
  ([[status body] success] (wrap-response [status body] success handle-failure))
  ([[status body] success failure]
   (if status
     (success body)
     (failure body))))

(defn make-request-async
  [request]
  (let [comm (chan)]
    (->> request
         (merge
          ;;get-transit-defaults
          get-json-defaults
          {:handler
           (fn [response]
             (put! comm response))})
         ajax-request)
     comm))

(defn make-request [request callback]
  (->> request
      (merge
       ;get-transit-defaults
       get-json-defaults
       {:handler
        (fn [response]
          (if (:error-handler request)
            (wrap-response response callback (:error-handler request))
            (wrap-response response callback handle-failure)))})
      ajax-request))

#_(defn save-diagram [values]
  (make-request 
   {:method :post
    :uri (api-url-build "/api/v2/diagram/save")
    :params values}
    #(prn "ajax add plant")))

#_(defn add-new-plant [values]
  (make-request 
   {:method :post
    :uri (api-url-build "/api/v2/plant/add")
    :params values}
    #(prn "ajax add plant")
    )
  )

(comment 
  (make-request-async
   {:method :post
    :uri (api-url-build "/api/v2/auth/login")
    :params {}}
   prn)

  (go 
    (prn (<! (make-request-async
            {:method :post
             :uri (api-url-build "/api/v2/auth/login")
             :params {}}
            prn))))

  (make-request {:method :post :uri (api-url-build "/api/v2/plant/add")} prn)
  (make-request {:uri (api-url-build "/api/v2/plant/search")} prn))
